import { apiRequest } from './client';
import type { AuditEntry, AuditPage } from '../lib/auditLog';

/**
 * The action log's two reads (V0.49). Thin, like every other module here: the query string is
 * built by `lib/auditLog.ts` so it can be tested without a server, and this only posts it.
 */

/** One page of rows. Page 0 comes with the vocabulary the labels are drawn from. */
export const fetchAuditPage = (query: string): Promise<AuditPage> =>
  apiRequest<AuditPage>(`/api/audit?${query}`);

/** One entry in full, including `detail` — what the row's drawer shows. */
export const fetchAuditEntry = (id: string): Promise<AuditEntry> =>
  apiRequest<AuditEntry>(`/api/audit/${encodeURIComponent(id)}`);
